import { apiFetch } from "./CommonApi";
import { notify } from "../Components/Common";

const downloadFile = (blob, fileName) => {
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(downloadUrl);
};

export const downloadOrders = (param) => {
  const url = param ? `service/orders/export/?${param}` : "service/orders/export/";
  return apiFetch("GET", url, null, true)
    .then((res) => {
      if (res?.ok) {
        return res.blob();
      }
      throw new Error("Failed to download orders");
    })
    .then((blob) => {
      downloadFile(blob, "orders.csv");
    });
};

export const loadServices = (param) => {
  const url = param ? `service/orders/?${param}` : "service/orders/?page=1";
  return apiFetch("GET", url, null, true)
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error("Failed to fetch services");
      }
    })
    .catch((error) => {
      console.error("Error", error);
      throw error;
    });
};

export const deleteService = (serviceId) => {
  return apiFetch("DELETE", `service/orders/${serviceId}/`, null, true)
    .then((res) => {
      if (res.ok) {
        return res;
      } else {
        throw new Error("Failed to delete service");
      }
    })
    .catch((error) => {
      console.error("Error", error);
      throw error;
    });
};

export const createService = (body) => {
  // console.log("data", data);
  console.log("body", body);
  return apiFetch("POST", "service/orders/", body, true)
    .then((res) => {
      if (res.ok) {
        return res;
      } else {
        throw new Error("Failed to create service");
      }
    })
    .catch((error) => {
      console.error("Error", error);
      throw error;
    });
};

export const loadAutoCompleteContacts = (text) => {
  return apiFetch(
    "GET",
    `whatsapp-business/contacts/autocomplete/?text=${text}`,
    null,
    true
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error("Something went wrong with contacts");
      }
    })
    .catch((error) => {
      console.error("Error", error);
      throw error;
    });
};

export const loadAutoCompleteProducts = (text) => {
  return apiFetch(
    "GET",
    `service/products/autocomplete?text=${text}`,
    null,
    true
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error("Something went wrong with products");
      }
    })
    .catch((error) => {
      console.error("Error", error);
      throw error;
    });
};

export const editService = (serviceId, body) => {
  return apiFetch("PUT", `service/orders/${serviceId}/`, body, true);
};
